import { cn } from '@qr-front/ui/utils'
import * as React from 'react'

export const Clone1LogoIcon = ({
	size = 32,
	bgFill = '#5660e8',
	fill = '#fff',
}: {
	size?: number
	bgFill?: string
	fill?: string
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width={32} height={32} rx={4} fill={bgFill} />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.999 6.1a1.1 1.1 0 0 1 1.1-1.1h7.7a1.1 1.1 0 0 1 1.1 1.1v7.7a1.1 1.1 0 0 1-1.1 1.1h-7.7a1.1 1.1 0 0 1-1.1-1.1zm3.3 3.3a1.1 1.1 0 0 1 1.1-1.1h1.1a1.1 1.1 0 0 1 1.1 1.1v1.1a1.1 1.1 0 0 1-1.1 1.1h-1.1a1.1 1.1 0 0 1-1.1-1.1zm-3.3 8.8a1.1 1.1 0 0 1 1.1-1.1h7.7a1.1 1.1 0 0 1 1.1 1.1v7.701a1.1 1.1 0 0 1-1.1 1.1h-7.7a1.1 1.1 0 0 1-1.1-1.1zm4.4 2.2a1.1 1.1 0 0 0-1.1 1.1v1.101a1.1 1.1 0 0 0 1.1 1.1h1.1a1.1 1.1 0 0 0 1.1-1.1v-1.1a1.1 1.1 0 0 0-1.1-1.1zM18.2 5a1.1 1.1 0 0 0-1.1 1.1v7.7a1.1 1.1 0 0 0 1.1 1.1h7.7a1.1 1.1 0 0 0 1.1-1.1V6.1A1.1 1.1 0 0 0 25.9 5zm2.2 4.4a1.1 1.1 0 0 1 1.1-1.1h1.1a1.1 1.1 0 0 1 1.1 1.1v1.1a1.1 1.1 0 0 1-1.1 1.1h-1.1a1.1 1.1 0 0 1-1.1-1.1z"
			fill={fill}
		/>
		<path
			d="M18.2 17.1a1.1 1.1 0 0 0-1.1 1.1v1.1a1.1 1.1 0 0 0 1.1 1.1h1.1v2.201a1.1 1.1 0 0 0 1.1 1.1h1.1a1.1 1.1 0 0 0 1.1-1.1v-2.2a1.1 1.1 0 0 0-1.1-1.1h-1.1v-1.1a1.1 1.1 0 0 0-1.1-1.1zm0 6.6a1.1 1.1 0 0 0-1.1 1.1v1.1a1.1 1.1 0 0 0 1.1 1.1h1.1a1.1 1.1 0 0 0 1.1-1.1v-1.1a1.1 1.1 0 0 0-1.1-1.1zm4.4-5.5a1.1 1.1 0 0 1 1.1-1.1h1.1a1.1 1.1 0 0 1 1.1 1.1v1.1a1.1 1.1 0 0 1-1.1 1.1h-1.1a1.1 1.1 0 0 1-1.1-1.1zm1.1 5.5a1.1 1.1 0 0 0-1.1 1.1v1.1a1.1 1.1 0 0 0 1.1 1.1h1.1a1.1 1.1 0 0 0 1.1-1.1v-1.1a1.1 1.1 0 0 0-1.1-1.1z"
			fill={fill}
		/>
	</svg>
)

export const Clone1LogoSvg = ({
	textClassName,
	size,
}: {
	textClassName?: string
	size?: number
}) => {
	return (
		<div className="flex items-center gap-2">
			<Clone1LogoIcon size={size} />
			<span className={cn('type-heading-3', textClassName)}>QRcreate</span>
		</div>
	)
}
